/** Run once after first user interaction or timeout — for analytics that must not block LCP. */
export function scheduleOnInteraction(task: () => void, timeoutMs = 5000): () => void {
    if (typeof window === 'undefined') {
        return () => undefined;
    }

    let ran = false;
    const run = () => {
        if (ran) {
            return;
        }
        ran = true;
        cleanup();
        task();
    };

    const events = ['scroll', 'click', 'keydown', 'touchstart'] as const;
    const opts: AddEventListenerOptions = { passive: true, once: true };
    const cleanup = () => {
        events.forEach((e) => window.removeEventListener(e, run, opts));
        window.clearTimeout(timer);
    };

    events.forEach((e) => window.addEventListener(e, run, opts));
    const timer = window.setTimeout(run, timeoutMs);

    return cleanup;
}
